export const GET_AD_GROUP_LOCATIONS="GET_AD_GROUP_LOCATIONS"
export const GET_AD_GROUP_LOCATIONS_SUCCESS="GET_AD_GROUP_LOCATIONS_SUCCESS"
export const GET_AD_GROUP_LOCATIONS_ERROR="GET_AD_GROUP_LOCATIONS_ERROR"
